import axios from '@/http/index';

const base = '';
export default {
  // 获取 顾客分析
  getAnalyse(params) {
    return axios.get(`${base}/erp/analyse/getAnalyse`, params).then((res) => res.data);
  },
  // 5.6新增顾客明细
  getCustomerAndMember(params) {
    return axios.get(`${base}/erp/analyse/getCustomerAndMember`, params).then((res) => res.data);
  },
  // 5.10顾客分析-顾客分析
  getCustomerAnalyseMsg(params) {
    return axios.get(`${base}/erp/saleStatistics/getCustomerAnalyseMsg`, params).then((res) => res.data);
  },
};
